'use strict';

angular.module('paizacloudApp')
  .directive('browserView', function($sce, $timeout, $cookies) {
    let idScopeMap = {};
    window.addEventListener('blur', () => {
      let iframeId = document.activeElement!.id;
      let scope = idScopeMap[iframeId];
      if(scope){
        scope.$apply(() => {
          scope.$emit('focus');
        });
      }
    });
    let idCounter = 1;

    return {
      template: require('./browserview.directive.html').default,
      restrict: 'EA',
      scope: {
        ngModel: '=',
        container: '=',
      },
      link: function(scope, element, attrs) {
        scope.ngModel.iconText = '🌍';
        scope.ngModel.srcUrl = scope.ngModel.urlField = scope.ngModel.url;
        scope.resizing = false;
        scope.iframeId = 'browseriframe' + (idCounter ++);
        let reloadAck = false;

        scope.getRealUrl = () => {
          let url = scope.ngModel.url;
          let parser = document.createElement('a');
          parser.href = '' + url;
          if(parser.hostname === 'localhost'){
            url = 'https://localhost-' + scope.container.containerHostname + (parser.port ? (':'+parser.port) : '') + parser.pathname.replace(/(^\/?)/,"/") + parser.search + parser.hash;
          }
          return url;
        };

        idScopeMap[scope.iframeId] = scope;
        scope.getIFrameUrl = (url) => {
          let parser = document.createElement('a');
          parser.href = '' + url;
          if(parser.hostname === 'localhost'){
            url = 'https://localhost-' + scope.container.containerHostname + (parser.port ? (':'+parser.port) : '') + parser.pathname.replace(/(^\/?)/,"/") + parser.search + parser.hash;
            parser.href = url;
          }

          if(parser.hostname === scope.container.containerHostname || parser.hostname === 'localhost-' + scope.container.containerHostname){
            let encodedOrigin = encodeURIComponent(location.origin);
            let origin = parser.protocol + '//' + parser.host; // 'parser.origin' does not work on IE11 .
            return origin + '/__frame__/' + encodedOrigin + parser.pathname.replace(/(^\/?)/,"/") + parser.search + parser.hash;
          }else{
            return url;
          }
        };

        // scope.iframeUrl = scope.getIFrameUrl(scope.ngModel.srcUrl);

        function getTrustedUrl(url){
          return $sce.trustAsResourceUrl(url);
        }
        scope.$watch('ngModel.srcUrl', (post, pre) => {
          console.log('browserview:watch:ngModel.srcUrl=', scope.ngModel.srcUrl);
          scope.trustedUrl = getTrustedUrl(scope.getIFrameUrl(scope.ngModel.srcUrl));
          if(post && post !== pre) {
            scope.container.saveDesktop();
          }
        });
        scope.submit = function(ev){
          console.log("submitted", ev);
        };
        scope.$watch('ngModel.url', function(post, pre){
          console.log('ngModel.url changed:', post, pre);
        });
        scope.keydown = (event) => {
          console.log("keydown", event, scope.ngModel.url);
          if(event.which === 13){
            if(scope.ngModel.url === scope.ngModel.urlField){
              // scope.reload();
              reloadByRecreatingElement();
            }else{
              scope.ngModel.srcUrl = scope.ngModel.url = scope.ngModel.urlField;
            }
          }
        };

        element.on('keydown', function(ev){
          if((ev.metaKey || ev.ctrlKey) && String.fromCharCode(ev.keyCode) === 'R'){ // 83
            console.log('keypress:', ev);
            scope.$apply(function(){
              scope.reload();
            });
            ev.preventDefault();
          }
        });

        scope.blur = (event) => {
          scope.ngModel.srcUrl = scope.ngModel.url = scope.ngModel.urlField;
        };

        let iframeElement;

        const receiveMessage = (event) => {
          console.log("receiveMessage1", event);
          if(!iframeElement){
            iframeElement = element.find('iframe')[0];
          }
          if(iframeElement.contentWindow !== event.source) {
            return;
          }
          console.log("receiveMessage2", event);

          // console.log("event:", event);
          // console.log("event.data", event.data);
          /*
            alert("here");
            // Check origin of the event!
            if (event.origin == "http://ops.epo.org") {
                var dataJSON = eval('(' + event.data + ')');
                // work with data / display data
                alert(dataJSON);
            }
            else {
                alert("Got message from unknown source.");
            }
          */
          if(event.data.type === 'load'){
            let location = event.data.location;
            let href = location.href;
            let title = event.data.title;
            if(href === 'about:blank'){
              return;
            }
            scope.$apply(function(){
              scope.ngModel.urlField = href;
              console.log('receiveMessage href=', href);
              scope.$emit('title', title);
            });
          }else
          if(event.data.type === 'click'){
            scope.$apply(function(){
              scope.$emit('iframeClick');
              scope.$parent.$emit('focus');
            });
          }
          if(event.data.type === 'reload_ack') {
            reloadAck = true;
          }

          if(event.data.type === 'open:browser') {
            const url = event.data.url;
            scope.$emit('open:browser', url);
          }
          if(event.data.type  === 'TOKEN_UPDATED') {
            console.log('receiveMessage:TOKEN_UPDATED');
            // scope.reload();
          }
        };

        window.addEventListener("message", receiveMessage, false);
        scope.$on('$destroy', () => {
          window.removeEventListener("message", receiveMessage, false);
        });

        /*
        $timeout(function(){
          scope.window.addListener('resize', function(cols, rows){
            console.log("browserView:Event: resize cols=" + cols + ", rows=" + rows);

            console.log("browserView:element=", element);
            console.log("browserView:ace=", scope.ace);
            var browserElement = $(element).find('.winview')[0];
            browserElement.style.width = cols + "px";
            browserElement.style.height = rows + "px";

          });

          scope.window.addListener('start-resizing', function(){
            scope.$apply(function(){
              scope.resizing = true;
              console.log('start-resizing');
            });
          });
          scope.window.addListener('end-resizing', function(){
            scope.$apply(function(){
              scope.resizing = false;
              console.log('end-resizing');
            });
          });
        }, 0);
        */
        console.log("browserview:link");
        scope.activated = true;
        scope.$on('focus', function(){
          console.log('browserview:on-focus');
          if(element[0].clientWidth !== 0) {
            scope.activated = true;
          }
        });

        function reloadByRecreatingElement(){
          console.log("Reloading by resetting iframe src...");
          let iframe = <HTMLIFrameElement>element.find('iframe')[0];
          iframe.setAttribute('src', <string>iframe.getAttribute('src'));
        }
        function reloadItr(bRecreate:boolean){

          let iframe = <HTMLIFrameElement>element.find('iframe')[0];
          let parser = document.createElement('a');
          parser.href = scope.ngModel.srcUrl;

          function reloadByPostingMessage(){
            console.log("Reloading by posting message...");

            let origin = parser.protocol + '//' + parser.host;
            iframe.contentWindow!.postMessage({
              type: 'reload',
            }, origin);
          }

          if(!bRecreate && iframe && (parser.hostname === scope.container.containerHostname || parser.hostname === 'localhost-' + scope.container.containerHostname)){
            reloadByPostingMessage();
            reloadAck = false;
            $timeout(() => {
              if(!reloadAck){
                reloadByRecreatingElement();
              }
            }, 1000);
          }else{
            reloadByRecreatingElement();
          }
        }
        scope.reload = function($event?){
          console.log("scope.reload...");
          const bRecreate = $event && ($event.ctrlKey || $event.altKey || $event.metaKey);

          if($event && ! $cookies.get('paiza-user-set-domain-cookie')) {
            window.open('https://paiza-user.cloud/set-domain-cookie.html', '_blank'); // TODO: コンフィグで環境によって切り替える
            $timeout(() => {
              $cookies.put('paiza-user-set-domain-cookie', 'ok', {samesite: "None", secure: true});
              scope.container.setTokenForAgentUrl(false);
              scope.container.setTokenForAgentUrl(true)
                .then(() => {
                  reloadItr(bRecreate);
                });
            }, 1000);
          }
          reloadItr(bRecreate);
          setTokenByPostingMessage();
        };

        function setTokenByPostingMessage(){
          console.log("Setting token by posting message...");

          let iframe = <HTMLIFrameElement>element.find('iframe')[0];
          let parser = document.createElement('a');
          parser.href = scope.ngModel.srcUrl;

          let origin = parser.protocol + '//' + parser.host;
          iframe.contentWindow!.postMessage({
            type: 'setToken',
            token: scope.container.containerToken,
          }, origin);
        }

        scope.$watch('container.socket', function(post, pre){
          if(!post){
            return;
          }
          if(!pre){
            console.log("socket connected. reloading...");
            scope.reload();
          }

          console.log("browserview:connected");
          let socket = scope.container.socket;

          // socket.on('systemd-status', function(status){
          //  console.log('systemd-status updated: ', status);
          socket.on('browser:reload', function(){
            console.log('browser:reload event');
            scope.reload();
          });
          socket.on('TOKEN_UPDATED', () => {
            console.log('browserview:TOKEN_UPDATED');
            scope.reload();
          });
          if(scope.ngModel.watchPaths){
            let reloadTimer;
            scope.ngModel.watchPaths.forEach(function(path){
              socket.emit('watch', path, {recursive: true, parent: true}, (err, eventName) => {
                if(err){
                  console.error("watch(" + path + ") error: ", err);
                  window.alert("watch(" + path + ") error: " + JSON.stringify(err, null, 2));
                  return;
                }
                console.log('watch event for:' + path);
                socket.on(eventName, () => {
                  if(reloadTimer){
                    $timeout.cancel(reloadTimer);
                    reloadTimer = null;
                  }
                  reloadTimer = $timeout(() => {
                    reloadTimer = null;
                    scope.reload();
                  }, 500);
                });
                scope.$on('$destroy', () => {
                  socket.emit('unwatch', eventName, () => {
                    console.log('unwatched ' + eventName);
                  });
                });
              });
            });
          }
        });
        scope.$emit('viewlinked');
      },
    };
  });
